<script>
    import {createEventDispatcher} from 'svelte/internal';

    export let table_columns = [];

    const dispatch = createEventDispatcher();

    const onSort = column => {
        if (column.sortable) {
            table_columns.map(item => {
                if (item.key !== column.key) {
                    item.sort_way = "";
                }
            });
            table_columns = table_columns;
            column.sort_way = column.sort_way === 'DESC' ? 'ASC' : 'DESC';
            dispatch('sort', column);
        }
    }
</script>

<thead>
<tr>
    {#each table_columns as column}
        <th class:sortable={ column.sortable } on:click="{ () => onSort(column) }">
            { column.name }
            {#if column.sortable }
                <span><i class="fa" class:fa-sort-desc="{ column.sort_way === 'DESC'}"
                         class:fa-sort-asc="{ column.sort_way === 'ASC'}"
                         class:fa-sort="{ !column.sort_way }"></i></span>
            {/if}
        </th>
    {/each}
</tr>
</thead>

<style>
    th.sortable {
        position: relative;
        vertical-align: middle;
        cursor: pointer;
    }

    th.sortable span {
        right: 10px;
    }
</style>